import type { HotItem } from '@/mocks/homeData';
import { todayHot } from '@/mocks/homeData';

function Trend({ trend }: { trend: HotItem['trend'] }) {
  if (trend === 'new') {
    return (
      <span className="flex items-center gap-1 rounded-md bg-accent-100 px-1.5 py-0.5 text-[11px] font-bold text-accent-800">
        NEW
      </span>
    );
  }
  const up = trend === 'up';
  return (
    <span className={`flex items-center gap-0.5 text-xs font-medium ${up ? 'text-primary-500' : 'text-foreground-400'}`}>
      <i className={up ? 'ri-arrow-up-s-line text-sm' : 'ri-arrow-down-s-line text-sm'} />
      {up ? '上升' : '回落'}
    </span>
  );
}

export default function TodayHot() {
  return (
    <section id="hot" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        {/* 分区头 */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-accent-700"># 今日 · 热度榜单</p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              此刻讨论度最高的<span className="text-primary-600">黑料话题</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">榜单每小时滚动一次，越往上，围观的人越多。</p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex h-8 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3">
              <i className="ri-time-line" /> 最近更新 09:12
            </span>
          </div>
        </div>

        {/* 榜单主体：标题+短摘要列表 */}
        <ol className="mt-8 grid gap-3 lg:grid-cols-2">
          {todayHot.map((h) => (
            <li key={h.rank}>
              <a
                href="#community"
                className="group flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition hover:border-primary-200 hover:bg-primary-50/40 md:p-5"
              >
                <span
                  className={`w-9 shrink-0 pt-0.5 text-center font-heading text-3xl font-black leading-none ${
                    Number(h.rank) <= 3 ? 'text-primary-500' : 'text-primary-200'
                  }`}
                >
                  {h.rank}
                </span>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">
                      #{h.tag}
                    </span>
                    <Trend trend={h.trend} />
                  </div>
                  <h3 className="mt-1.5 font-medium leading-snug text-foreground-950 transition group-hover:text-primary-700 md:text-[15px]">
                    {h.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">{h.summary}</p>
                  <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-fill text-accent-600" />
                      <b className="text-foreground-800">{h.heat}</b> 热度
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line" />
                      {h.time}
                    </span>
                    <span className="ml-auto flex items-center gap-1 font-medium text-primary-600 opacity-0 transition group-hover:opacity-100">
                      去看热议 <i className="ri-arrow-right-s-line text-lg" />
                    </span>
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ol>

        <div className="mt-6 flex justify-center">
          <a
            href="#archive"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
          >
            查看往期热榜汇总
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}